import { render } from "./B2bPageAddPartiesServices.vue?vue&type=template&id=14537ab2&scoped=true&lang=pug"
import script from "./B2bPageAddPartiesServices.vue?vue&type=script&lang=js"
export * from "./B2bPageAddPartiesServices.vue?vue&type=script&lang=js"

import "./B2bPageAddPartiesServices.vue?vue&type=style&index=0&id=14537ab2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14537ab2"]])

export default __exports__